import { isSuccess } from '@devexperts/remote-data-ts'
import { createSelector } from '@reduxjs/toolkit'
import { Service } from '@/models/service'
import { servicesSlice } from '../servicesSlice'

export const servicesAsRecordSelector = createSelector(
  [servicesSlice.selectors.services],
  (services): Record<Service['serviceId'], Service> => {
    const serviceRecord: Record<Service['serviceId'], Service> = {}

    if (!isSuccess(services)) {
      return serviceRecord
    }

    const addServiceToRecord = (service: Service) =>
      (serviceRecord[service.serviceId] = service)

    services.value.extraFeaturedServices.forEach(addServiceToRecord)
    services.value.extraServices.forEach(addServiceToRecord)
    services.value.includedServices.forEach(addServiceToRecord)
    services.value.ticketServices.forEach(addServiceToRecord)

    return serviceRecord
  }
)
